bitCounter